import _default from './Sticky';
export { _default as default };